import React, {useEffect, useState} from 'react';
import {HStack, VStack} from 'native-base';
import CustomCheckbox from '../../common/CustomCheckbox';
import CustomButtonV2 from '../../common/CustomButtonV2';
import FormInput from '../../common/FormInput';
import AppText from '../../common/AppText';
import {fetchApi} from '../../../services/HTTP';
import {t} from '../../../services/i18n';
import {Colors} from '../../../styles/Colors';
import {GlobalStyleAttributes} from '../../../styles/GlobalStyles';

const WebhookFormFields = ({params, values, setFieldValue, touched, errors}) => {
    const [catalog, setCatalog] = useState([]);
    const isEdit = !!params?.id;

    useEffect(() => {
        if (isEdit) return;
        fetchApi('webhooks/events', 'get', null, false, true)
            .then((events) => setCatalog(Array.isArray(events) ? events : []))
            .catch(() => setCatalog([]));
    }, [isEdit]);

    const selected = values.events || [];
    const allSelected = catalog.length > 0 && catalog.every((event) => selected.includes(event));

    const toggleEvent = (event, checked) => {
        setFieldValue('events', checked ? [...selected, event] : selected.filter((item) => item !== event));
    };

    const renderEvents = () => {
        if (isEdit) {
            return (
                <VStack>
                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('webhookEvents')}</AppText>
                    <AppText color={Colors.newDesign.darkGrey}>{t(params.event)}</AppText>
                </VStack>
            );
        }

        return (
            <>
                <HStack justifyContent={'space-between'} alignItems={'center'} width={'100%'}>
                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>
                        {t('webhookEvents')}
                    </AppText>
                    <CustomButtonV2
                        type={'link'}
                        text={allSelected ? t('deselectAll') : t('selectAll')}
                        applyHoverOnText
                        textProps={{color: Colors.newDesign.mainBlue}}
                        onClick={() => setFieldValue('events', allSelected ? [] : catalog)}
                    />
                </HStack>
                {catalog.map((event) => (
                    <HStack marginTop={'10px'} key={event}>
                        <CustomCheckbox
                            isChecked={selected.includes(event)}
                            onChange={(checked) => toggleEvent(event, checked)}
                            text={<AppText>{t(event)}</AppText>}
                        />
                    </HStack>
                ))}
                {touched.events && errors.events && (
                    <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText}>{errors.events}</AppText>
                )}
            </>
        );
    };

    return (
        <VStack>
            <FormInput
                width={'100%'}
                value={values.name}
                label={t('name')}
                required
                errorHeight={'auto'}
                containerProps={{mb: '1rem'}}
                onChangeCallback={(val) => setFieldValue('name', val)}
                error={touched.name && errors.name}
            />
            <FormInput
                width={'100%'}
                value={values.url}
                label={t('webhookUrl')}
                required
                helper={t('webhookUrlHelper')}
                errorHeight={'auto'}
                containerProps={{mb: '1rem'}}
                onChangeCallback={(val) => setFieldValue('url', val)}
                error={touched.url && errors.url}
            />
            {renderEvents()}
        </VStack>
    );
};

export default WebhookFormFields;
